<template>
    <div class="container">
      <el-row style="margin-bottom:20px">
          <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/member-center' }">个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>简历</el-breadcrumb-item>
        </el-breadcrumb>
      </el-row>
      <!--
        <el-form ref="form" :model="searchFormData" >
          <el-row type="flex" class="row-bg" justify="space-around">

            <el-col :span="6">
              <el-form-item label="">
                <el-input  placeholder="输入名称搜索" v-model="searchFormData.keyword" clearable=""></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-button type="primary" @click="search">搜索</el-button>
            </el-col>

            <el-col :span="6" :offset="6" style="text-align:right">
              <el-button type="primary" @click="add">添加简历</el-button>
            </el-col>
          </el-row>
        </el-form>
-->
<el-button type="primary" @click="add">添加简历</el-button>
        <el-table
          ref="table"
          v-loading="searchLoading"
          :data="tableData"
          element-loading-text="正在查询"
          fit
          stripe
          highlight-current-row
        >
          <el-table-column align="center" label="简历名称" prop="name"> </el-table-column>
          <el-table-column align="center" label="是否公开"  prop="status">
            <template slot-scope="{row}">
                  <el-switch
                      v-model="row.status"
                      active-color="#13ce66"
                      inactive-color="#c7c7c7"
                      :active-value="1"
                      :inactive-value="2"
                      active-text="公开"
                      inactive-text="不公开"
                      @change="openResume($event,row.resume_id)"
                      >
                    </el-switch>
             </template>

          </el-table-column>
          <el-table-column align="center" label="创建时间"  prop="created_at"/>
          <el-table-column label="操作" fixed="right" align="center" class-name="small-padding fixed-width" width="200">
            <template slot-scope="{row}">
            
              <el-button size="mini" @click="edit(row.resume_id)">
                编辑
              </el-button>

              <el-button  type="primary" size="mini" @click="show(row.resume_id)">
                预览
              </el-button>

            </template>
          </el-table-column>
      </el-table>
      <!--
      <div style="text-align:center;padding:20px">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
   -->

  </div>
</template>

<script>
import { userResumeList,userResumeStatusUpdate } from "@/api/user/index";

  export default {
    name: "Resume",
    data() {
      return {
       
        searchLoading: false,
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        tableData:[],


        searchFormData:{
          keyword:"",
          page:0,
          limit:0
        }

      }
    },

    mounted() {
      this.fetchData();
    },

    methods: {

     
      add(){
        this.$router.push({
        name: "publish-resume",});
      },

      edit(id){
        this.$router.push({ name: "publish-resume", query: { resume_id: id } });
        
      },

      show(resume_id){
        this.$router.push({ name: "resume-detail", query: { resume_id: resume_id } });
        
      },

      openResume($event,resume_id){
        var that=this;
        userResumeStatusUpdate({resume_id:resume_id,status:$event}).then((response) => {
                console.log(response);
                if(response.code==200){
                    that.fetchData();
                  
                }
              });
      },

      search(){
        this.fetchData();
      },

      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        userResumeList(that.searchFormData).then((response) => {
          console.log(response);
          if(response.code==200){
            that.tableData=response.data;
            //that.pageProps.records = response.data.data;
            //that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },
      
    }
  }
</script>

